module.exports = __webpack_public_path__ + "static/img/15075G_01_20170522_LC.d230dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15075G_01_20170522_LC.png
// module id = sBSv
// module chunks = 0